import cx from 'classnames';
import dynamic from 'next/dynamic';

import styles from './index.module.scss';

const Card = dynamic(import('./card'));

const Layout = ({ background, isCard = false, children }) => {
  return (
    <section className={styles.wrapper} style={{ background }}>
      <div className={cx(styles.container, 'gap-x-32')}>
        <div className={styles.main}>{children}</div>

        {isCard && (
          <div className={cx(styles.side, 'sm_px-20')}>
            <Card />
          </div>
        )}
      </div>
    </section>
  );
};

export default Layout;
